import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/sapInventory'

const sapInventory = axios.create({
  baseURL
})

interceptorsSetup(sapInventory)

export default class SAPInventory {
  static async get (fiscalYear, inventoryNumber) {
    const result = await sapInventory.get('/', {
      params: {
        fiscalYear: fiscalYear,
        inventoryNumber: inventoryNumber
      }
    })
    return result.data
  }
  static async saveInventory (inventory) {
    const result = await sapInventory.post('/', inventory)
    return result.data
  }
}
